var controllerEvents = require('ControllerEvents.js');

var SearchServerController = function (host, _, core, helpers, interControllerEmitter, console, events, $) {

    var Promise  = core.Promise
    , Repository = core.Repository
    , Guid       = core.Guid
    , Models     = core.Models
    , moment     = core.Moment
    , host       = host
    , md5                = require("md5")
    , self       = this;

    var galleryFiltersTable    = core.Repository.galleryFilters,
    galleryPrimaryFiltersTable = core.Repository.galleryPrimaryFilters,
    pictureMetaDataItemsTable  = core.Repository.pictureMetaDataItems,
    galleryKeysTable           = core.Repository.galleryKeys,
    galleryDetailsTable        = core.Repository.galleryDetails,
    searchResultOverviewTable  = core.Repository.searchResultOverviews,
    cascadeSetMappingsTable    = core.Repository.cascadeSetMappings;

    var inMemoryPictureData      = []
    ,   inMemoryPictureDataByIds = function (ids) {
        
        return _(inMemoryPictureData).keyBy('PictureId').at(ids).compact().value();
    }

    var clearAndBulkAdd = function (table, list) {
        return function () {
            return table.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).delete()
                .then(function () { return table.bulkAdd(list) })
        }
    }

    var refreshSelectedItemPictureMetaDataItem = function (list) {        
        return function () {

            inMemoryPictureData = list;

            if(!list.length) return;

            return pictureMetaDataItemsTable.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).toArray(function (items) {
                
                var idsBy       = _(items).groupBy('Selected').mapValues(function(x){ return _.map(x,'PictureId') }).value()
                , unSelectedIds = idsBy['0']
                , selectedIds   = idsBy['1']
                , promises      = [];

                console.log('Selected:', selectedIds, 'Unselected:', unSelectedIds);

                if(selectedIds){

                    var matches = inMemoryPictureDataByIds(selectedIds);

                    if(matches.length){

                        var updated = _.map(matches, function (x) { return _.assign(x, { Selected: 1 }) });

                        console.log('matches', matches, 'updated', updated);

                        promises.push(pictureMetaDataItemsTable.bulkPut(updated));

                    }
                    
                }

                if(unSelectedIds){

                    promises.push(pictureMetaDataItemsTable.bulkDelete(unSelectedIds));
                }


                return promises.length && Promise.all(promises);
            })

        }
    }

    var clearAndAdd = function (table, record) {
        return function () {
            return table.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).delete()
                .then(function () { return table.add(record) })
        }
    }


    var bulkPut = function (table, list) {
        return function () {
            return table.bulkPut(list);
        }
    }


    self.getGalleryDetails = function (_galleryKey, params) {
        
        if(!_galleryKey) return Promise.resolve();

        console.log('params', params)

        var galleryKey = _galleryKey.GalleryKey || _galleryKey;
        return galleryDetailsTable.where('GalleryKey').equals(galleryKey).first()
            .then(function (details) {
                //if (details === undefined) {
                    return _.at(params,'noFetch')[0] 
                        ? details
                        : self.loadGalleryDetails(galleryKey);

                //} else {
                //    return details;
                //}
            })
    }

    self.loadGalleryDetails = function (galleryKey) {

        console.error('Getting Gallery Details From Server', galleryKey);

        if(!galleryKey) return Promise.reject();

        var request = {
            galleryKey: galleryKey.toUpperCase() //'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
        }

        var galleryDetailsUpdate;

        return core.SyncService.loadGalleryDetails(request)
            .then(function (loadGalleryDetailsResult) {

                console.error('loadGalleryDetailsResult', loadGalleryDetailsResult);

                interControllerEmitter.emit(controllerEvents.gallery_details_loaded, loadGalleryDetailsResult);

                console.info('Processing gallery details', loadGalleryDetailsResult);

                galleryDetailsUpdate = helpers.createInstanceWithValues(Models.GalleryDetails,
                    {
                        GalleryKey        : loadGalleryDetailsResult.GalleryKey.toUpperCase(),
                        Name              : loadGalleryDetailsResult.Name,
                        GalleryLogoUrl    : loadGalleryDetailsResult.GalleryLogoUrl,
                        SearchResultLimit : loadGalleryDetailsResult.SearchResultLimit,
                        DefaultPageSize   : loadGalleryDetailsResult.DefaultPageSize,
                        IsCurrentGallery  : 1,
                        LastLoadedOn      : moment().toDate(),
                        GalleryStartDate  : loadGalleryDetailsResult.GalleryStartDate,
                        IsContentManagementEnabled:  loadGalleryDetailsResult.IsContentManagementEnabled,
                        ContentManagerTokenHash: loadGalleryDetailsResult.ContentManagerTokenHash,
                        IsPictureApprovalModeEnabled : loadGalleryDetailsResult.IsPictureApprovalModeEnabled,
                        MetaDataLastUpdatedOn : loadGalleryDetailsResult.MetaDataLastUpdatedOn,
                        PrimaryDateFilterField : loadGalleryDetailsResult.PrimaryDateFilterField,
                        DefaultStartDateOffset : loadGalleryDetailsResult.DefaultStartDateOffset
                    });

                var hash = md5("A")
                return galleryDetailsTable.clear()
                    .then(function () {
                        return galleryDetailsTable.add(galleryDetailsUpdate)
                    })
                    .then(function (galleryDetails) {
                        return galleryDetailsUpdate;
                    })


            }, function (fail) {

                console.error('something wrong',fail);
                return null;
            })
    }

    self.loadPrimaryFilters = function (galleryKey, primaryDateField) {
        console.error('Building primary filters');

        return new Promise(function(resolve, reject) {
            var galleryPrimaryFilterList = [];
            var newFilterItem = helpers.createInstanceWithValues(Models.GalleryPrimaryFilter,
                {
                    GalleryKey                 : galleryKey.toUpperCase(),
                    FieldName                  : primaryDateField,
                    FieldLabel                 : 'Visit Date',
                    FieldDescription           : null,
                    Sequence                   : 1,
                    IsTypeAheadField           : 0,
                    TypeAheadMinimumCharacters : 2,
                    TypeAheadResultLimit       : 20,
                    DataType                   : 'Date',
                    RenderingType              : 'Calendar',
                    IsRangeFilter              : 1,
                    FixedFilterValues          : null,
                    CascadeSet                 : null,
                    CascadeSetSequence         : null
                });

            galleryPrimaryFilterList.push(newFilterItem);
            clearAndBulkAdd(galleryPrimaryFiltersTable, galleryPrimaryFilterList);
            resolve(galleryPrimaryFilterList);
        });

    }

    self.loadFilters = function (galleryKey, primaryDateFilterField, visitDateFrom, visitDateTo) {

        console.error('Getting filters');

        var request = {
            galleryKey: galleryKey.toUpperCase() //'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
            ,primaryDateFilterField: primaryDateFilterField 
            ,visitDateFrom: visitDateFrom 
            ,visitDateTo: visitDateTo 
        }
        var galleryFilterList = [];

        return core.SyncService.loadGalleryFilters(request)
            .then(function (loadFiltersResult) {

                console.error('loadFiltersResult', loadFiltersResult);

                loadFiltersResult.forEach(function (nthFilter) {

                    console.info('Processing a filter', nthFilter);
                    if(nthFilter.FieldName === primaryDateFilterField)
                    {
                        console.info('skip adding primary date filter', nthFilter);
                    }
                    else
                    {   
                        var newFilterItem = helpers.createInstanceWithValues(Models.GalleryFilter,
                            {
                                GalleryKey                 : galleryKey.toUpperCase(),
                                FieldName                  : nthFilter.FieldName,
                                FieldLabel                 : nthFilter.FieldLabel,
                                FieldDescription           : nthFilter.FieldDescription,
                                Sequence                   : nthFilter.Sequence,
                                IsTypeAheadField           : nthFilter.IsTypeAheadField,
                                TypeAheadMinimumCharacters : nthFilter.TypeAheadMinimumCharacters,
                                TypeAheadResultLimit       : nthFilter.TypeAheadResultLimit,
                                DataType                   : nthFilter.DataType,
                                RenderingType              : nthFilter.RenderingType,
                                IsRangeFilter              : nthFilter.IsRangeFilter,
                                FixedFilterValues          : nthFilter.FixedFilterValues,
                                CascadeSet                 : nthFilter.CascadeSet,
                                CascadeSetSequence         : nthFilter.CascadeSetSequence
                            });

                        galleryFilterList.push(newFilterItem);
                    }

                });
            })
            .then(clearAndBulkAdd(galleryFiltersTable, galleryFilterList))
            .then(function () {
                return galleryFilterList;

            })
    }
    
    self.getMapping = function(galleryKey, cascadeSet, primaryDateFilterField, visitDateFrom, visitDateTo){

        // return global.mutex.synchronize(function(){
               
            console.log('Getting Relational Category Brand Products Tree');

            return self.loadGalleryDetails(galleryKey, {noFetch: true}).then(function(currentGallery) {
                // return  cascadeSetMappingsTable.where('[GalleryKey+CascadeSet]').equals([galleryKey,cascadeSet]).first().then(function(storedCascadeSetDoc){
                return  cascadeSetMappingsTable.where({GalleryKey: galleryKey, CascadeSet: cascadeSet}).first().then(function(storedCascadeSetDoc){
                
                    var deserializedCascadeSet;
                    if(storedCascadeSetDoc){
                        deserializedCascadeSet = JSON.parse(storedCascadeSetDoc.Document);
                    }
                    
                    if(!storedCascadeSetDoc || (storedCascadeSetDoc.TimeStamp !== currentGallery.MetaDataLastUpdatedOn || storedCascadeSetDoc.VisitDateFrom !== visitDateFrom || storedCascadeSetDoc.VisitDateTo !== visitDateTo)){
                        return self.loadMapping(galleryKey, cascadeSet, primaryDateFilterField, visitDateFrom, visitDateTo).then(function(dbCascadeSet){
                            var cascadeSetMappingsUpdate;
                         
                            if(!storedCascadeSetDoc){
                                cascadeSetMappingsUpdate = 
                                {
                                    GalleryKey        : galleryKey,
                                    CascadeSet        : cascadeSet,
                                    TimeStamp         : currentGallery.MetaDataLastUpdatedOn || Date.now(), //for galleries that aren't tracking metadata updates.
                                    Document          : JSON.stringify(dbCascadeSet)
                                };
                            }
                            else
                            {
                                cascadeSetMappingsUpdate = 
                                {
                                    id                : storedCascadeSetDoc.id,
                                    GalleryKey        : galleryKey,
                                    CascadeSet        : cascadeSet,
                                    TimeStamp         : currentGallery.MetaDataLastUpdatedOn || Date.now(),
                                    Document          : JSON.stringify(dbCascadeSet)
                                };
                            }
                            return cascadeSetMappingsTable.put(cascadeSetMappingsUpdate).then(function(result){
                                console.log("doneblahfromdb");
                                return dbCascadeSet;
                            });
                        });
            
                    }
                    else{
                        console.log("doneblahfromlocal");
                        return deserializedCascadeSet;
                    }
                });
            
            });
        // });
    }

    self.loadMapping = function(galleryKey, cascadeSet, primaryDateFilterField, visitDateFrom, visitDateTo){

        console.error('Getting Relational Category Brand Products Tree');

        var request = {
            galleryKey: galleryKey.toUpperCase(),
            cascadeSet: cascadeSet //'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
            ,primaryDateFilterField: primaryDateFilterField 
            ,visitDateFrom: visitDateFrom 
            ,visitDateTo: visitDateTo 
        }

        return core.SyncService.loadMapping(request).then(helpers.toNbsp).then(JSON.parse) ; //.then(toNbsp);
    }

    var selectedPictureItems = function () { return pictureMetaDataItemsTable.where({ Selected: 1, GalleryKey: host.CurrentGalleryDetails.GalleryKey }) }
    , pictureItemsId         = function () { return pictureMetaDataItemsTable.where('id') }


    self.getCount    = function () { return selectedPictureItems().count() }
    self.unselectAll = function () { return selectedPictureItems().modify({ Selected: 0 }).then(self.getCount) }

    var mappedFromMatch = function(selectionState){ return function (match) {
        return _.assign(match, { Selected: selectionState});// { PictureId: match.pictureId, GalleryKey: match.GalleryKey, Selected: selectionState}         
    }}

    self.setPictureSelectionState = function (pictureId, selectionState)  { 
        
        var match = _.find(inMemoryPictureData, { PictureId: pictureId} );

        //console.warn('matched', match);

        return selectionState ? pictureMetaDataItemsTable.put(mappedFromMatch(selectionState)(match)).then(self.getCount)
                              : pictureMetaDataItemsTable.delete(pictureId).then(self.getCount);
            
    }

    self.setPictureListSelectionState = function (ids, selectionState) {

        var matches = inMemoryPictureDataByIds(ids);

        //console.warn('matched', matches);

        return selectionState ? pictureMetaDataItemsTable.bulkPut(_.map(matches, mappedFromMatch(selectionState))).then(self.getCount)
                              : pictureMetaDataItemsTable.bulkDelete(ids).then(self.getCount);
                        
    }

    self.findPictures = function (galleryKey, filterData) {

        console.log('Getting Session Info From Server');

        var request = {
            galleryKey: galleryKey.toUpperCase() //'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
        }

        host.AuthorViewMode() && _.assign(request, { contentManagerCode : host.ContentManagerCode() })

        var pictureMetaDataResults = [];
        var searchResultOverviewHolder = [];

        return core.SyncService.findPictures(request, filterData)
            .then(function (findPicturesResult) {

                console.error('findPicturesResult', findPicturesResult);

                var searchKey = Guid.create().toString().toUpperCase();

                findPicturesResult.Content.PictureMetaData.forEach(function (nthResult) {

                    //console.info('Processing a picture metadata item', nthResult);

                    var metadataItem = helpers.createInstanceWithValues(Models.PictureMetaDataItem,
                        {
                            GalleryKey     : galleryKey.toUpperCase(),
                            SearchKey      : searchKey,
                            PictureId      : nthResult.PictureId,
                            ThumbNailUrl   : nthResult.ThumbNailUrl,
                            PictureUrl     : nthResult.PictureUrl,
                            Selected       : 0,
                            Latitude       : nthResult.Latitude,
                            Longitude      : nthResult.Longitude,
                            ImageSource    : nthResult.ImageSource,
                            TimeStamp      : nthResult.TimeStamp,
                            MetaData       : nthResult.MetaData,
                            FileNameFields : findPicturesResult.Content.FileNameFields,
                            DisplayFields  : findPicturesResult.Content.DisplayFields
                        });

                    pictureMetaDataResults.push(metadataItem);
                });


                var currentSearchOverView = helpers.createInstanceWithValues(Models.SearchResultOverview,
                    {
                        GalleryKey  : galleryKey.toUpperCase(),
                        SearchKey   : searchKey,
                        ResultCount : findPicturesResult.Content.ResultCount,
                        SearchedOn  : moment().toDate(),
                        IsPublicMapViewEnabled  : findPicturesResult.Content.IsPublicMapViewEnabled
                    })
                return currentSearchOverView;

            })
            .then(function (searchResultSummary) {
                return searchResultOverviewTable.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).delete()
                    .then(function () { return searchResultOverviewTable.add(searchResultSummary) })
            })
            .then(refreshSelectedItemPictureMetaDataItem(pictureMetaDataResults))

            .then(function () {
                // return pictureMetaDataResults;
                return self.getPicturePage(galleryKey, { PageNumber: 1, PageSize: 25 });

            })
    }

    self.___getPicturePage = function (galleryKey, pageInfo) {

        console.log('Getting Picture Page', pageInfo.PageNumber);

        return searchResultOverviewTable.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).first()
            .then(function (currentSearchOverview) {
                console.warn('Overview', currentSearchOverview);
                return pictureMetaDataItemsTable.where('GalleryKey').equals(galleryKey)
                    .and(function (nthPicture) {
                        return pageInfo.Option === "Selected Photos" ? nthPicture.Selected : (!nthPicture.Selected || nthPicture.SearchKey === currentSearchOverview.SearchKey);
                    })
                    .toArray()
                    .then(function (metaData) {
                        return self.getGalleryDetails(galleryKey, {noFetch: true})
                            .then(function (galleryDetails) {
                                return {
                                    CurrentPage : pageInfo.PageNumber,
                                    PageSize    : galleryDetails.DefaultPageSize,
                                    MetaData    : _.take(_.slice(metaData, (pageInfo.PageNumber - 1) * galleryDetails.DefaultPageSize), galleryDetails.DefaultPageSize),
                                    Overview    : currentSearchOverview
                                }
                            })
                    })
            })
    }

    self.getPicturePage = function (galleryKey, pageInfo) {

        console.log('Getting Picture Page', pageInfo.PageNumber);

        return pictureMetaDataItemsTable.where('GalleryKey').equals(galleryKey).and(function (nthPicture) { return nthPicture.Selected })
        .toArray(function (selectedPictureItems) {
            console.log('selected items', selectedPictureItems);
            return searchResultOverviewTable.where('GalleryKey').equals(host.CurrentGalleryDetails.GalleryKey).first()
                .then(function (currentSearchOverview) {
                    var metaData = pageInfo.Option === "Selected Photos" ? selectedPictureItems : inMemoryPictureData;
                    console.warn('Overview', currentSearchOverview, selectedPictureItems, inMemoryPictureData);
                    return self.getGalleryDetails(galleryKey, {noFetch: true})
                        .then(function (galleryDetails) {

                            var pagedMeta = _.take(_.slice(metaData, (pageInfo.PageNumber - 1) * galleryDetails.DefaultPageSize), galleryDetails.DefaultPageSize),

                            updatedMeta = pageInfo.Option === "Selected Photos" ? pagedMeta : _.each(pagedMeta, function (meta) {
                                
                                 _.assign(meta, { Selected : _.some(selectedPictureItems, { PictureId : meta.PictureId }) ? 1 : 0 } ) 
                                
                                });
                            
                            console.log('paged data', updatedMeta);

                            return {
                                CurrentPage : pageInfo.PageNumber,
                                PageSize    : galleryDetails.DefaultPageSize,
                                MetaData    : updatedMeta,
                                Overview    : currentSearchOverview
                            }
                        })
                })

        })

    }

    var getSelected = function (galleryKey) { return pictureMetaDataItemsTable.where('GalleryKey').equals(galleryKey).and(function (nthRecord) { return nthRecord.Selected === 1 }) }

    self.downloadPictures = function (galleryKey, clientToken, downloadOptions) {

        console.log('Getting Session Info From Server');
        var request = {
            galleryKey  : galleryKey.toUpperCase(),
            clientToken : clientToken.toUpperCase()//'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
        }

        return getSelected(galleryKey).toArray().then(function (selectedRecords) {
                
                var downloadRequest = {
                    DownloadFormat: downloadOptions.Option
                   ,PictureIds    : _.map(selectedRecords, 'PictureId')
                   ,UseOriginalSize: downloadOptions.Option === 'Zip'
                }
                
                return core.SyncService.prepareBulkPictureExport(request, JSON.stringify(downloadRequest))
                    .then(function (prepareBulkPictureExportResult) {

                        console.error('prepareBulkPictureExportResult', prepareBulkPictureExportResult);
                        var downloadRequestParameters = {
                            galleryKey     : galleryKey.toUpperCase(),
                            clientToken    : clientToken.toUpperCase(),
                            fileIdentifier : prepareBulkPictureExportResult.Content,//'E1E9E388-EB65-43B9-8B5C-8C2F22A2C81D'
                            formatOption   : downloadOptions.Option
                        }
                        //// event >> UI
                        setTimeout(events.makeTrigger(events.file_downloaded, downloadOptions), 2000);

                        return core.SyncService.downloadpictureexportfile(downloadRequestParameters)
                    })
            }
            )
    }

    self.changeStatusOfPictures = function (galleryKey, contentManagerToken, statusChangeOptions) {

        console.log('Getting Session Info From Server');
        var request = {
            galleryKey         : galleryKey.toUpperCase(),
            contentManagerToken: contentManagerToken
        }

        return getSelected(galleryKey).toArray().then(function (selectedRecords) {
                
            
            var status            = statusChangeOptions.Status
            , filtered            = _.reject(selectedRecords || [], helpers.matchesStatus(status))
            , statusChangeRequest = {  
                 ApprovalStatus  : status
                ,ApprovalComments: ''
                ,PictureIds      : _.map(filtered,'PictureId') 
            }
            console.log('selectedRecords', selectedRecords, status, filtered);
            
            return (
                
            _.some(filtered) 
                        
            ? core.SyncService.prepareBulkPictureStatusChange(request, JSON.stringify(statusChangeRequest))

                .then(function (result) {

                    console.error('prepareBulkPictureStatusChange', result);

                    _(inMemoryPictureDataByIds(statusChangeRequest.PictureIds)).each(helpers.setStatus(status));

                    return (_.first(_.at(result,'Message')) === 'OK') 
                            && getSelected(galleryKey)
                                .modify(helpers.setStatus(status));
                            
                })

            : Promise.resolve(false)    

            ).then(events.makeTrigger(events.status_changed, statusChangeRequest));

        });
    }
    
    self.recordFileDownload = function (fileId, state) {

        console.log('logging file download', state);
        return fileHeadersTable.where('FileId').equals(fileId).modify({ DownloadedOn: (state ? Date() : undefined) })
            .then(function () {

                fileHeadersTable.where('FileId').equals(fileId).toArray(function (headerFromDB) {

                    events.emitter.emit(events.file_info, _.first(headerFromDB));
                })

            });

    }

    self.onDownloadRequest = function (fileHeader) {

        console.log('DownloadRequest for', fileHeader);

        var url = helpers.format('Sync/DownloadFile?sessionId={0}&fileId={1}', host.GetSessionIdForTransport(), fileHeader.FileId);

        return self.recordFileDownload(fileHeader.FileId, true).then(function () {

            return $.fileDownload(global.apiEndpoint + url, { httpMethod: "GET" });

        });


    }

}


module.exports = SearchServerController;